module.exports = __webpack_public_path__ + "img/type5.adc0b2c6.png";